import {css, ListItemIcon, Stack, styled} from '@mui/material';
import {Link} from 'react-router-dom';
import {StyledListItemProps} from '../Sidebar/types';

const StyledItemWrapper = styled(Stack)`
	padding: 8px 16px 8px 0;
	flex-direction: row;
	align-items: center;
`;

const StyledNavLink = styled(Link)`
	border-radius: 8px;
	padding: 12px 16px;
	display: flex;
	align-items: center;
	background-color: transparent;
	text-decoration: none;
	width: 100%;
	height: 36px;

	.MuiListItemIcon-root {
		color: ${({theme}) => theme.palette.action.active};
	}

	.MuiListItemText-root .MuiTypography-root {
		color: ${({theme}) => theme.palette.text.secondary};
	}

	&.active,
	&:hover {
		background-color: ${({theme}) => theme.colors.brand.secondary?.lightBlue};

		.MuiListItemIcon-root {
			color: ${({theme}) => theme.palette.primary.main};
		}

		.MuiListItemText-root .MuiTypography-root {
			color: ${({theme}) => theme.palette.text.primary};
		}
	}
`;

export const StyledModalButton = styled('div')<StyledListItemProps>`
	border-radius: 8px;
	padding: 12px 16px;
	justify-content: center;
	display: flex;
	width: 100%;
	height: 36px;

	${({$isBooking}) =>
		$isBooking &&
		css`
			background-color: ${({theme}) => theme.colors.brand.secondary?.lightBlue};

			.MuiListItemIcon-root {
				color: ${({theme}) => theme.palette.primary.main};
			}

			.MuiListItemText-root .MuiTypography-root {
				color: ${({theme}) => theme.palette.text.primary};
			}
		`};

	&:is(:hover) {
		background-color: ${({theme}) => theme.colors.brand.secondary?.lightBlue};

		.MuiListItemIcon-root {
			color: ${({theme}) => theme.palette.primary.main};
		}

		.MuiListItemText-root .MuiTypography-root {
			color: ${({theme}) => theme.palette.text.primary};
		}
	}

	& .MuiTouchRipple-root .MuiTouchRipple-child {
		background-color: ${({theme}) => theme.palette.primary.main};
	}
`;

export const StyledListItemIcon = styled(ListItemIcon)<StyledListItemProps>`
	min-width: 56px;
	margin-right: -20px;
`;

const ActiveBorder = styled('div')<{$isActive: boolean}>`
	width: 4px;
	height: 20px;
	border-radius: 0 4px 4px 0;
	background-color: ${({theme, $isActive}) =>
		$isActive ? theme.palette.primary.main : 'transparent'};
	flex-shrink: 0;
	margin-right: 12px;
`;

export {StyledItemWrapper, StyledNavLink, ActiveBorder};
